import { render, staticRenderFns } from "./ModListUserBodyRoleComp.vue?vue&type=template&id=57aec002&scoped=true&"
import script from "./ModListUserBodyRoleComp.vue?vue&type=script&lang=ts&"
export * from "./ModListUserBodyRoleComp.vue?vue&type=script&lang=ts&"
import style0 from "./ModListUserBodyRoleComp.vue?vue&type=style&index=0&id=57aec002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aec002",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
